var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoToPlansBlueicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.461,
    height: 18.832,
    viewBox: "0 0 18.461 18.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140240",
    "data-name": "Rectangle 140240",
    width: 0.701,
    height: 1.869,
    rx: 0.35,
    fill: "#1450ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Go-to-plans",
    transform: "translate(-104.704 -365.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reload-outline",
    transform: "translate(122.536 381.756) rotate(172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M14.238,12.135l-.854.994A7.765,7.765,0,1,1,15.09,5.177",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M2.427,2.154V.272A.272.272,0,0,0,2.154,0H.273A.272.272,0,0,0,.08.465L1.962,2.346a.272.272,0,0,0,.465-.192Z",
    transform: "translate(12.842 10.845)",
    fill: "#1450ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1138",
    "data-name": "Group 1138",
    transform: "translate(109 369.89)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_377",
    "data-name": "Rectangle 377",
    width: 10,
    height: 10,
    transform: "translate(0 0.11)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1137",
    "data-name": "Group 1137",
    transform: "translate(1 0.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1133",
    "data-name": "Group 1133",
    transform: "translate(1.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_380",
    "data-name": "Rectangle 380"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill",
    width: 0.701,
    height: 1.869,
    rx: 0.35,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_161042",
    "data-name": "Group 161042",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    d: "M0,.5H.7M.5,0V1.869m.2-.5H0m.2.5V0",
    fill: "none",
    stroke: "#1450ff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_380-2",
    "data-name": "Rectangle 380",
    transform: "translate(1.869)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-2",
    width: 0.701,
    height: 1.869,
    rx: 0.35,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_161043",
    "data-name": "Group 161043",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M0,.5H.7M.5,0V1.869m.2-.5H0m.2.5V0",
    fill: "none",
    stroke: "#1450ff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_380-3",
    "data-name": "Rectangle 380",
    transform: "translate(3.739)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-3",
    width: 0.701,
    height: 1.869,
    rx: 0.35,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_161044",
    "data-name": "Group 161044",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M0,.5H.7M.5,0V1.869m.2-.5H0m.2.5V0",
    fill: "none",
    stroke: "#1450ff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_381",
    "data-name": "Rectangle 381",
    transform: "translate(0 0.783)",
    fill: "none",
    stroke: "#1450ff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 9,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7,
    height: 8,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1134",
    "data-name": "Group 1134",
    transform: "translate(1.663 2.804)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_382",
    "data-name": "Rectangle 382",
    width: 2.804,
    height: 0.701,
    rx: 0.35,
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_383",
    "data-name": "Rectangle 383",
    width: 4.44,
    height: 0.701,
    rx: 0.35,
    transform: "translate(0 1.735)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_384",
    "data-name": "Rectangle 384",
    width: 4.44,
    height: 0.701,
    rx: 0.35,
    transform: "translate(0 3.469)",
    fill: "#1450ff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToPlansBlueicon);
export default __webpack_public_path__ + "static/media/go-to-plans-blueicon.9cf4e765c66914c6e39f26caf736867c.svg";
export { ForwardRef as ReactComponent };